import styled from 'styled-components';

const BlueButton = styled.button`
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.8px;
    padding: 12px 20px;
    background-color: blue;

    img {
        display: inline-block;
        width: 15px;
        margin: 0 10px 0 0;
    }
`;

export default BlueButton;
